module.exports = __webpack_public_path__ + "media/images/lb/775-2940f26f4979a5b49f92da1284193f89.svg";